
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import { ApiStateData } from "@/domain/entities/Api";
import { ListPickupV2Controller } from "@/app/ui/controllers/ListPickupV2Controller";
import {
  ListPickupParams,
  PickupCorporateSummaryRequest
} from "@/data/payload/api/ListPickupV2Request";
import { PickupCorporateSummary } from "@/domain/entities/ListPickupV2";
import ModalRequestPickup from "../../components/modal-request-pickup/index.vue";
import ModalActivePickupWarning from "../../components/modal-active-pickup-warning/index.vue";
import ModalSelectClientSchedule from "../../components/modal-select-client-schedule/index.vue";
import SavedAddressList from "../../components/saved-address-list/index.vue";
import ModalPickupRequestSuccess from "../../components/modal-pickup-request-success/index.vue";
import { PickupRequestMode } from "../../components/modal-request-pickup/types";
import { PickupSuccessPayload } from "../../components/modal-request-pickup/types";
import PickupBookingSummary from "../components/pickup-booking-summary.vue";
import { PickupScheduleController } from "@/app/ui/controllers/PickupScheduleController";
import { ApiRequestList } from "@/domain/entities/MainApp";
import { PickupCorporateAddress } from "@/domain/entities/PickupSchedule";
import { AddressFormSuccessPayload } from "../../components/saved-address-list/types";
import { patchPickupSummaryAddress } from "../utils/patch-pickup-summary-address";
import PickupCorporateV2SummaryCard from "./components/summary-card.vue";
import ListPickupFilterBar from "@/app/ui/views/pickup/list-pickup/list/components/list-pickup-filter-bar.vue";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { ListPickupV2 } from "../../../../../../domain/entities/ListPickupV2";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import CalendarOutlined from "@/app/ui/components/lp-icon/svgs/calendar-outlined.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import PickupStatusBadge from "../detail/components/pickup-status-badge.vue";
import buildDhlLabelPrintListColumn from "@/app/ui/views/pickup/common/buildDhlLabelPrintListColumn";
import openLabelPdfWithAuth from "@/app/ui/views/pickup/common/openLabelPdfWithAuth";
import { FlagsPermissionHorde } from "@/feature-flags";
import ModalAddNewAddress from "../../components/modal-add-new-address/index.vue";

@Options({
  components: {
    PickupBookingSummary,
    ModalRequestPickup,
    ModalActivePickupWarning,
    ModalSelectClientSchedule,
    ModalPickupRequestSuccess,
    SavedAddressList,
    PickupCorporateV2SummaryCard,
    ListPickupFilterBar,
    Title,
    PickupStatusBadge,
    CalendarOutlined,
    ModalAddNewAddress
  }
})
class PickupList extends Vue {
  openModalSttPickupList = false;
  openModalPickupRequestSuccess = false;
  openModalRequestPickup = false;
  isChangeAddressOpen = false;
  isActivePickupWarningOpen = false;
  showSelectClientSchedule = false;

  pickupSuccess = {
    orderId: "",
    totalKoli: 0,
    totalWeightKg: 0,
    pickupDate: "",
    pickupTimeStart: ""
  };

  filter = {
    lsShipmentId: "" as any,
    lsPickupSchedule: "" as any,
    lsTransportTypeId: "" as any,
    lsServiceCodes: "" as any,
    lsLastStatus: "" as any,
    startDate: "",
    endDate: ""
  };

  apiListData = new ApiStateData({
    loading: true
  });
  listData = new ResponsePayloadV2();
  isFirstLanding = true;
  addressPrefetchPromise: Promise<void> | null = null;
  apiSummaryData = new ApiStateData({
    loading: true
  });
  pickupCorporateSummary = new PickupCorporateSummary();

  mounted() {
    // call api get list from filter
    this.fetchSummary();

    if (!this.isInternalAccount) {
      this.addressPrefetchPromise = this.updateListPickupCorporateAddress();
    }
  }

  get isInternalAccount(): boolean {
    return AccountController.accountData.account_type === "internal";
  }

  get isDhlWhitelist(): boolean {
    return FlagsPermissionHorde.dhl_first_mile_client_whitelist.isEnabled();
  }

  get selectedAddress(): PickupCorporateAddress {
    return PickupScheduleController.selectedAddress;
  }

  async fetchSummary() {
    this.apiSummaryData.loading = true;
    try {
      this.pickupCorporateSummary = new PickupCorporateSummary();

      this.pickupCorporateSummary = await ListPickupV2Controller.getPickupCorporateSummary(
        new PickupCorporateSummaryRequest()
      );
    } catch (error) {
      this.apiSummaryData.errorType = parsingErrorResponse(error).type;
    } finally {
      this.apiSummaryData.loading = false;
    }
  }

  updateListPickupCorporateAddress(selectAddress = true): Promise<void> {
    return PickupScheduleController.getListPickupCorporateAddress(
      new ApiRequestList({
        page: 1,
        limit: 50,
        isTotalData: false,
        selectAddress
      })
    );
  }

  async onOpenSavedAddressList(): Promise<void> {
    await this.addressPrefetchPromise;
    console.log("complete promise")
    this.isChangeAddressOpen = true;
  }

  onSelectAddress(address: PickupCorporateAddress): void {
    PickupScheduleController.setSelectedAddressPickupCorporateAddress(address);
    this.patchSummaryAddress(address);
  }

  async onDefaultAddressChanged(): Promise<void> {
    await this.updateListPickupCorporateAddress(false);
    const defaultAddress = PickupScheduleController.listPickupCorporateAddress.find(
      (address) => address.pcaIsDefault
    );
    if (defaultAddress?.pcaId) {
      this.patchSummaryAddress(defaultAddress);
    }
  }

  async onAddressFormSuccess(
    payload: AddressFormSuccessPayload
  ): Promise<void> {
    const selectAddress = payload.isDefault || !this.selectedAddress.pcaId;
    await this.updateListPickupCorporateAddress(selectAddress);
    await this.syncSummaryAddress();
    this.closeModalAddAddress();
  }

  async onAddressDeleted(): Promise<void> {
    const previousSelectedId = this.selectedAddress.pcaId;
    await this.updateListPickupCorporateAddress(false);

    const selectedStillExists =
      !!previousSelectedId && this.selectedAddress.pcaId === previousSelectedId;

    if (!selectedStillExists) {
      const defaultAddress = PickupScheduleController.listPickupCorporateAddress.find(
        (address) => address.pcaIsDefault
      );
      if (defaultAddress?.pcaId) {
        PickupScheduleController.setSelectedAddressPickupCorporateAddress(
          defaultAddress
        );
        this.patchSummaryAddress(defaultAddress);
        return;
      }
    }

    await this.syncSummaryAddress();
  }

  patchSummaryAddress(address: PickupCorporateAddress): void {
    this.pickupCorporateSummary = patchPickupSummaryAddress(
      this.pickupCorporateSummary,
      address
    );
  }

  async syncSummaryAddress(): Promise<void> {
    if (this.selectedAddress.pcaId) {
      this.patchSummaryAddress(this.selectedAddress);
      return;
    }
    await this.fetchSummary();
  }

  onRequestPickup() {
    if (this.pickupCorporateSummary.activePickupCount) {
      this.isActivePickupWarningOpen = true;
      return;
    }

    this.onOpenModalRequestPickup();
  }

  onOpenModalRequestPickup() {
    this.isActivePickupWarningOpen = false;

    this.openModalRequestPickup = true;
  }

  onOpenModalRequestPickupManual() {
    this.isActivePickupWarningOpen = false;

    this.openModalRequestPickup = true;
  }

  onRequestPickupSuccess(payload: PickupSuccessPayload) {
    this.openModalRequestPickup = false;
    this.pickupSuccess = payload;
    this.openModalPickupRequestSuccess = true;

    this.fetchSummary();

    this.listData.pagination.page = 1;
    this.getListPickupList();
  }

  onCloseModalPickupRequestSuccess() {
    this.openModalPickupRequestSuccess = false;
    this.fetchSummary();
  }

  onViewStt() {
    this.$router.push({
      name: "booking-v2-list",
      query: {
        summary_filter: "ongoing"
      }
    });
  }

  get requestPickupMode(): PickupRequestMode {
    if (this.pickupCorporateSummary.state === "none") {
      return "blank";
    }

    return this.pickupCorporateSummary.state as PickupRequestMode;
  }

  get requestPickupPrefill(): any {
    const s = this.pickupCorporateSummary;
    return {
      sttCount: s.sttCount,
      koli: s.koliCount,
      weight: s.weightKg,
      specialHandling: s.specialHandling,
      serviceCodes: s.productTypes,
      addressId: s.defaultAddressId
    };
  }

  get columns() {
    return [
      {
        name: "No",
        styleHead: "w-12 text-left",
        render: (_: ListPickupV2, index: number) =>
          `<div class="text-left">${index +
            1 +
            this.listData.pagination.limit *
              (this.listData.pagination.page - 1)}</div>`
      },
      {
        name: this.$t("pickupV2.list.table.orderId"),
        styleHead: "w-56 text-left",
        "custom-slot": true,
        slotName: "orderId"
      },
      ...(AccountController.accountData.isInternalAccount
        ? [
            {
              name: "Klien",
              styleHead: "w-40 text-left",
              "custom-slot": true,
              slotName: "klien"
            }
          ]
        : []),
      {
        name: this.$t("pickupV2.list.table.status"),
        styleHead: "w-48 text-left",
        "custom-slot": true,
        slotName: "status"
      },
      {
        name: this.$t("pickupV2.list.table.totalRequest"),
        styleHead: "w-60 text-left whitespace-nowrap",
        sortBy: "estimate_total_koli",
        render: (item: ListPickupV2) => {
          return `<div class="overflow-ellipsis text-left font-semibold">
                    ${`${this.formatNumber(item.estimateTotalKoli)} ${this.$t(
                      "pickupV2.list.piece"
                    )}`}
                  </div>`;
        },
        tooltipHeader: () => this.$t("pickupV2.list.table.totalRequestTooltip")
      },
      {
        name: this.$t("pickupV2.list.table.totalPickup"),
        styleHead: "w-60 text-left whitespace-nowrap",
        sortBy: "estimate_total_shipment",
        "custom-slot": true,
        slotName: "totalPickup",
        tooltipHeader: () =>
          this.$t("pickupV2.list.table.agentHubProcessedTooltip")
      },
      {
        name: this.$t("pickupV2.list.table.agentHubProcessed"),
        styleHead: "w-76 text-left whitespace-nowrap",
        sortBy: "agent_hub_processed_stt",
        render: (item: ListPickupV2) => {
          return `<div class="overflow-ellipsis text-left font-semibold">
          ${
            item.agentHubProcessedStt
              ? `${`${this.formatNumber(item.agentHubProcessedStt)} AWB`}
                    <span class="font-normal">
                      (${this.formatNumber(
                        item.agentHubProcessedKoli
                      )} ${this.$t("pickupV2.list.piece")})
                     </span>
                     `
              : "-"
          }
                  </div>`;
        },
        tooltipHeader: () =>
          this.$t("pickupV2.list.table.agentHubProcessedTooltip")
      },
      {
        name: this.$t("pickupV2.list.table.createdAt"),
        styleHead: "w-56 text-left whitespace-no-wrap align-middle",
        sortBy: "created_at",
        render: (item: ListPickupV2) =>
          item.createdAt
            ? `<div class="flex flex-col text-sm text-black-lp-100">
                  <div class="overflow-ellipsis text-left"> ${
                    item.formatCreatedAt
                  } </div>
                  <div class="truncate text-gray-lp-600 w-32">
                    ${item.createdBy || "-"}
                  </div>
                </div>`
            : `<div class="overflow-ellipsis text-left"> - </div>`
      },
      ...buildDhlLabelPrintListColumn({
        rows: this.listData.data,
        t: (key: string) => this.$t(key),
        onPrint: this.onPrintDhlLabel
      })
    ];
  }

  get isEmpty(): boolean {
    return !this.listData.data.length;
  }

  get sumFilter(): number {
    return (
      (this.filter.lsPickupSchedule ? 1 : 0) +
      (this.filter.lsTransportTypeId ? 1 : 0) +
      (this.filter.lsServiceCodes?.length ? 1 : 0) +
      (this.filter.lsLastStatus?.length ? 1 : 0)
    );
  }

  get iconEmpty() {
    return this.isFilter ? "ill_spot_search_2" : "noData_empty_new";
  }

  get emptyHeaderMessage() {
    return this.isFilter
      ? this.$t("pickupV2.list.notFoundTitle")
      : this.$t("pickupV2.list.emptyTitle");
  }

  get emptyMessage() {
    return this.isFilter
      ? this.$t("pickupV2.list.notFoundMessage")
      : this.$t("pickupV2.list.emptyMessage");
  }

  get isFilter(): boolean {
    return Object.entries(this.filter).some(([_, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === "string") {
        return value.trim() !== "";
      }

      return !!value;
    });
  }

  onChangeAdvancedFilter() {
    this.listData.pagination.page = 1;
    this.getListPickupList();
    this.isFirstLanding = false;
  }

  async onResetAdvancedFilter() {
    this.apiListData.loading = true;
    this.listData.pagination.page = 1;
    await this.getListPickupList();
  }

  activeSortBy = "";
  activeSortDirection = "";

  onSort({ sortBy, sortDirection }: { sortBy: string; sortDirection: string }) {
    this.activeSortBy = sortBy;
    this.activeSortDirection = sortDirection;
    this.getListPickupList();
  }

  async getListPickupList() {
    this.apiListData.loading = true;
    try {
      const sortBy = this.activeSortBy
        ? `${this.activeSortBy}_${this.activeSortDirection.toLowerCase()}`
        : "";

      this.listData.data = [];

      this.listData = await ListPickupV2Controller.getListPickup(
        new ListPickupParams({
          page: this.listData.pagination.page,
          pickupSchedule: this.filter.lsPickupSchedule,
          transportType: this.filter.lsTransportTypeId,
          serviceCode: this.filter.lsServiceCodes,
          lastStatus: this.filter.lsLastStatus,
          shipmentId: this.filter.lsShipmentId,
          sortBy,
          createdAtFrom: this.filter.startDate,
          createdAtTo: this.filter.endDate,
          isTotalData: true
        })
      );
      this.apiListData.errorType = "";
    } catch (error) {
      this.apiListData.errorType = parsingErrorResponse(error).type;
    } finally {
      this.apiListData.loading = false;
    }
  }

  formatNumber(value: number): string {
    if (!value) return "0";
    return new Intl.NumberFormat(
      AccountController.accountData.accountIsForeign ? "my-MY" : "id-ID"
    ).format(value);
  }

  onToDetail(item: ListPickupV2) {
    this.$router.push(`/pickup/list-pickup-v2/${item.shipmentId}`);
  }

  onPrintDhlLabel(item: ListPickupV2) {
    const tab = window.open("about:blank", "_blank");
    openLabelPdfWithAuth(item.dhlLabelPrintUrl, tab);
  }
  formatClientName(clientRef: string) {
    const splitValue = clientRef.split(' - ')

    if(splitValue.length > 1) {
      return splitValue[1]
    }

    return clientRef
  }

  isSelectClientScheduleOpen = false;

  onOpenScheduleConfig(): void {
    if (this.isInternalAccount) {
      this.showSelectClientSchedule = true;
      return;
    }
    this.$router.push("/pickup/pickup-schedule-config");
  }

  onCloseSelectClientSchedule(): void {
    this.isSelectClientScheduleOpen = false;
  }

  onSelectClientScheduleContinue(client: any): void {
    this.showSelectClientSchedule = false;
    this.$router.push({
      path: "/pickup/pickup-schedule-config",
      query: { client_id: String(client.clientId) }
    });
  }

  get getIsInActive(): boolean {
    return AccountController.accountData.isClientActive;
  }

  get validationAccount(): boolean {
    return AccountController.validationAccount;
  }

  isAddAddress = false;

  showModalAddAddress() {
    this.isAddAddress = true;
  }

  closeModalAddAddress() {
    this.isAddAddress = false;
  }
}

export default PickupList;
